import { Box, Container, Grid, Typography, useTheme } from '@mui/material';
import React from 'react';

import TheoryOfAboutUs from './TheoryOfAboutUs';

export default function AboutUs() {
  const theme = useTheme();

  return (
    <Container id="aboutUs" sx={{ pt: { xs: 6, sm: 10 } }}>
      <Grid container spacing={10}>
        <Grid item xs={12} md={6} sx={{ display: 'block', justifyContent: 'center' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <img
              style={{
                height: {
                  xs: theme.breakpoints.values.xs,
                  sm: theme.breakpoints.values.sm * 0.6,
                  md: theme.breakpoints.values.md * 0.8,
                  lg: theme.breakpoints.values.lg * 1,
                },
                width: {
                  xs: theme.breakpoints.values.xs,
                  sm: theme.breakpoints.values.sm * 0.6,
                  md: theme.breakpoints.values.md * 0.8,
                  lg: theme.breakpoints.values.lg * 1,
                },
                borderTopLeftRadius: '5%',
                borderTopRightRadius: '5%',
                borderBottomLeftRadius: '5%',
                borderBottomRightRadius: '5%',
                // objectFit: 'cover',
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.5)'
              }}
              src="/assets/landing/abunekelementos.jpg"
              alt="አቡቀለምሲስ"
            />
          </Box>
          <Typography variant="h6" color="text.secondary" textAlign="center" sx={{ pt: 2, fontStyle: 'italic' }}>
            ብፁዕ አቡነ ቀሌምንጦስ በኢትዮጵያ ኦርቶዶክስ ተዋህዶ ቤተ ክርስቲያን በመንበረ ፓትርያርክ ጠቅላይ ጽሕፈት ቤት የሰንበት ትምህርት ቤቶች ማደራጃ መምሪያና የሰሜን ሸዋ ሀገረ
            ስብከት ሊቀ ጳጳስ
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <TheoryOfAboutUs />
        </Grid>
      </Grid>
    </Container>
  );
}
